var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 67,
    viewBox: "0 0 39 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_3106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1478 35.3275C36.395 37.5411 36.6091 39.4547 36.8789 41.874C25.0362 46.2252 13.1316 50.5993 1.16975 54.9961C0.818504 48.5684 0.856191 48.4953 6.47306 46.376C15.3612 43.0212 24.2553 39.6786 33.1494 36.3391C34.0283 36.0085 34.9282 35.7373 36.1493 35.3275H36.1478Z",
    fill: "#5A82BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 58.9223C0.688918 58.1742 1.24216 57.0514 2.08937 56.7345C13.6005 52.4366 25.1538 48.2515 36.6544 44.0542C36.879 44.3239 37.09 44.4625 37.1247 44.6377C37.8563 48.2241 36.4865 50.6348 33.0153 51.8699C27.0246 54.0135 21.1379 56.5456 15.019 58.2047C10.3594 59.4677 5.40733 59.6322 0.58641 60.2858C0.390437 59.8318 0.195972 59.3778 0 58.9223H0Z",
    fill: "#5A82BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4022 33.7613C31.4324 34.9085 29.1561 35.9125 26.7969 36.6377C25.8698 36.9226 24.6382 36.8632 23.7458 36.4823C17.7897 33.9365 11.8488 31.345 6.0133 28.5371C5.1254 28.1105 4.41688 26.5169 4.31438 25.3986C4.17116 23.8462 4.67919 22.2328 4.95656 20.3207C14.6798 24.7588 24.1754 29.0917 34.4022 33.7597V33.7613Z",
    fill: "#5A82BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.81677 19.0121C12.2799 15.1286 16.9516 11.1019 22.2609 8.32301C25.0271 6.87566 28.9209 7.62676 32.3052 7.38452C32.2751 8.47994 32.6821 10.1878 32.1485 10.5778C26.8165 14.472 21.3504 18.1787 15.8586 21.8428C15.2692 22.2358 14.1808 22.2983 13.5024 22.0378C11.4116 21.2379 9.40662 20.2065 6.81828 19.0105L6.81677 19.0121Z",
    fill: "#5A82BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0602 23.4425C22.5549 19.6657 27.7738 16.0778 32.9927 12.4914L34.0465 12.8052C33.7887 15.639 34.6223 19.623 33.0877 21.1084C26.2769 27.7038 24.4212 27.6931 17.0602 23.4425Z",
    fill: "#5A82BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.74004 29.73C10.1875 32.6049 16.0999 35.2422 21.9971 37.8718C15.533 43.5926 9.70513 39.8767 3.91189 37.046C3.37221 36.7824 3.30287 35.2102 3.29081 34.2412C3.27423 32.963 3.52899 31.6802 3.74004 29.73Z",
    fill: "#5A82BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8147 5.15866C10.5343 1.34528 11.493 0.127983 14.8909 0.0518066C18.0249 -0.0182755 21.1635 -0.0137049 24.2976 0.044189C27.7376 0.108177 28.6647 1.24168 28.4959 5.15866H10.8147Z",
    fill: "#5A82BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3813 61.8749C28.7808 65.6045 27.8099 66.8812 24.4241 66.9543C21.2901 67.0213 18.153 67.0046 15.019 66.9558C11.5427 66.9025 10.6156 65.8162 10.7212 61.8734H28.3813V61.8749Z",
    fill: "#5A82BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5737 59.0883C24.9186 56.8259 31.2636 54.562 38.0126 52.1548C38.3608 54.7189 38.6593 56.9234 39.0015 59.4479H18.6867C18.649 59.3275 18.6113 59.2087 18.5721 59.0883H18.5737Z",
    fill: "#5A82BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.653 7.5567C14.6059 11.1172 10.1589 14.2526 5.14648 17.7887C5.62888 13.8504 6.01932 10.6632 6.3992 7.5567H19.653Z",
    fill: "#5A82BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6387 28.0785C29.527 26.1528 31.841 24.6095 34.6027 22.7675C35.0187 26.005 35.3836 28.8357 35.8268 32.2804C32.652 30.8285 29.9099 29.5731 26.6387 28.077V28.0785Z",
    fill: "#5A82BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.85869 46.0439C2.19184 43.3595 2.45414 41.2509 2.75413 38.8209C5.54297 40.0138 8.06046 41.091 11.2744 42.4652C7.9474 43.7297 5.22338 44.7657 1.85718 46.0439H1.85869Z",
    fill: "#5A82BE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_3106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 67,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotal);
export default __webpack_public_path__ + "static/media/total.527d18fb32f2bd08c80231821067e0c7.svg";
export { ForwardRef as ReactComponent };